// extracted by mini-css-extract-plugin
export default {"root":"SearchMapPriceLabel_root__7HwBx","priceLabel":"SearchMapPriceLabel_priceLabel__ldOm4","priceLabelActive":"SearchMapPriceLabel_priceLabelActive__fZk9M"};